import { library } from "@fortawesome/fontawesome-svg-core";
import { faGlasses, faCakeCandles } from "@fortawesome/pro-light-svg-icons";

library.add(faGlasses, faCakeCandles);
